<template>
  <div>
    <text-box-title title="Pugliese Campground">
      <div class="col-md-6 mt-3 board-list">
        The Pugliese Campground opened in 2006 with the the help of a $50,000 grant from the Charles M. Pugliese and 
        Thelma M. Pugliese Charitable Foundation. The Pugliese Campground offers RV camping lots with water, electric, and trash.
      </div>
      <div class="col-md-6 mt-3 board-list">
        <div class="text-beige-01 bg-primary font-size-15 p-2">
          Fees
        </div>
        
        <ul class="no-dots font-size-15 fee-list mt-3">
          <li>
            Daily:  $25.00
          </li>
          <li> 
            Weekly: $115.00
          </li>
          <li> 
            Monthly:  $300.00
          </li>
          <li>
            Seasonal: $1,170.00
          </li>
        </ul>

        <div class="mt-3">
          All fees are to be paid in advance.
        </div>
        <div class="mt-2">
          Click Pugliese Camping Rules for more information.
        </div>
      
      </div>
    </text-box-title>

    <text-box-title class="mt-3" title="Sam Kerr RV Campground">
      <div class="col-md-6 mt-3 board-list">
        <p>
          The Campground offers RV camping with water, electric (30 and 50 amp available), sewer, and trash.
        </p>
        <p>
          Each month’s camping fees will include 1000 kilowatts of electricity. For each kilowatt used above 1000 kw, a $0.15 fee per kilowatt will be assessed (due with rent).
        </p>
        <p class="text-bold">
          Call park office at (740) 733-7941 to check for availability.
        </p>
      </div>
      <div class="col-md-6 mt-3 board-list">
        <div class="text-beige-01 bg-primary font-size-15 p-2">
          Fees
        </div>
        
        <ul class="no-dots font-size-15 fee-list mt-3">
          <li>
            Daily: $35.00
          </li>
          <li> 
            Weekly: $180.00
          </li>
          <li> 
            Monthly: $600.00 + KW charge
          </li>
          <li>
            Seasonal: $1,800.00 + KW charge
          </li>
        </ul>

        <div class="mt-3">
          Click Sam Kerr RV Park Rules for more information.
        </div>
        <div class="mt-3">
          <i class="material-icons text-primary">info</i>
          Use of the camping facilities is at the Visitor’s sole risk and no liability or responsibility for personal injury or 
          property, damage, or loss is assumed by the Board of Park Commissioners of Friendship Park, its agents, servants, or employees.
        </div>
      
      </div>
    </text-box-title>
  </div>
</template>

<script>
import TextBoxTitle from '@/components/layout/TextBoxTitle.vue'

export default {
  components: {
    TextBoxTitle
  },
  data () {
    return {}
  },
  props: [],
  mounted: function() {
    //called on launch
  },
  methods: {}
}

</script>

<style scoped>

.fee-list li {
  margin-bottom: 0.5em;
}

</style>